// Adds a "remaining seats: X/Y" span next to each <a href=…workshopId=N> link
// inside a description container, using the live availability from the Redux
// workshops entity. Idempotent: re-runs update the existing span instead of
// duplicating it.
const injectSeatsIntoDescription = (container, workshopsById) => {
  if (!container) return;
  const anchors = container.querySelectorAll('a[href*="workshopId="]');
  anchors.forEach((anchor) => {
    const href = anchor.getAttribute('href') || '';
    const match = href.match(/[?&]workshopId=(\d+)/);
    if (!match) return;
    const child = workshopsById?.[match[1]];
    const availability = child?.availability;
    const usedSeats = child?.usedSeats || 0;
    const existing = anchor.parentNode?.querySelector(':scope > .umbrella-child-seats');
    if (!availability) {
      if (existing) existing.remove();
      return;
    }
    const text = `availability: ${availability - usedSeats}/${availability}`;
    if (existing) existing.textContent = text;
    else {
      const span = document.createElement('span');
      span.className = 'umbrella-child-seats umbrella-child-description';
      span.style.marginLeft = '8px';
      span.textContent = text;
      anchor.insertAdjacentElement('afterend', span);
    }
  });
};

export default injectSeatsIntoDescription;
